module.exports = __webpack_public_path__ + "media/vedio1.87240bce.mp4";